import { useQuery } from '@tanstack/vue-query';
import type { MaybeRefOrGetter } from 'vue';
import { queries } from '~/keys';
import type { ClientSummary } from '~/types/client';

type ClientListResponse = { success: boolean; data: { items: ClientSummary[] } };

export const HOLD_CLIENT_SEARCH_LIMIT = 8;

// The agent's registered clients (ID-36) for the hold dialog's "Who is this for?" step. Empty search → most recent.
export const useHoldClientSearchQuery = (search: MaybeRefOrGetter<string>, enabled: MaybeRefOrGetter<boolean>) => {
  const authStore = useAuthStore();
  const term = computed(() => toValue(search).trim());

  return useQuery({
    queryKey: computed(() => queries.exclusiveUnits.holdClients(term.value).queryKey),
    queryFn: () =>
      $fetch<ClientListResponse>('/api/agent/clients', {
        headers: { Authorization: `Bearer ${authStore.token}` },
        query: { search: term.value || undefined, limit: HOLD_CLIENT_SEARCH_LIMIT },
      }).then((res) => res.data.items),
    enabled: computed(() => !!authStore.token && toValue(enabled)),
    staleTime: 30_000,
    retry: false,
    throwOnError: false,
  });
};
